module.exports = __webpack_public_path__ + "images/regenstrief_logo.png";